import { shallowRef } from 'vue';

const mapInstance = shallowRef(null);

export default function useDgMap() {
  return { mapInstance };
}
